import React, { useEffect } from "react";
import { FAQ } from "./FAQ/FAQ";
import { Accreditations } from "../../components/Accreditations";
import { SearchCourse } from "./SearchCourse/SearchCourse";
import { useSelector } from "react-redux";

import bgImage from "../../assets/img/img-09-10-23/body-image-bg-2.svg";
import { Courses } from "./Services/Courses";
import { Guarantees } from "../../components/Guarantees";
import { trackFunnel } from "../../helpers/analytics";

export const CoursePage = () => {
  const courses = useSelector((state) => state.courses.courses);
  const centres = useSelector((state) => state.courses.centres);
  const notFound = useSelector((state) => state.courses.not_found);
  // every date at the "Virtual" centre = a live online course: no location to choose (see SearchCourse)
  const onlineOnly =
    courses?.length > 0 &&
    centres?.length > 0 &&
    centres.every((c) => c?.name === "Virtual");

  // Funnel: top of the booking funnel. Landed on the availability page (before
  // postcode), and again once venue results are shown.
  useEffect(() => {
    trackFunnel("view_course_page");
  }, []);
  useEffect(() => {
    if (courses?.length)
      trackFunnel("view_course_availability", { venues: courses.length });
  }, [courses?.length]);

  return (
    <div
      className="wrapper header-fixed bg-primary-100 bg-styles-top-center"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <main className="content">
        <section className="section-40 pb-100 pb-md-30">
          <div className="container container-900">
            <div
              className="firs-screen-home--container mb-30 r-4"
              style={{ minHeight: "90px" }}
            >
              <div className="firs-screen-home__content">
                {/* Emergency First Aid at Work */}
                <h2 className="heading-2">
                  {courses?.length
                    ? `${courses[0]?.name} (${
                        courses?.length ? `${courses[0]?.pcode}` : ""
                      })`
                    : ""}
                </h2>
                {/* <p className="heading-3 title-16-mob">6 Hours ({courses?.length ? `${courses[0]?.pcode}` : ''})</p> */}
              </div>
            </div>
            <h3 className="heading-3 title-16-mob">Course Availability</h3>
            {/* no dates scheduled anywhere: the message below says so, so no "choose your location" line */}
            {notFound && !courses?.length ? null : (
              <p>
                {onlineOnly
                  ? "This course runs live online, so you can book from anywhere. Choose a date below."
                  : courses?.length
                  ? "Showing courses for your location and date \u2014 change either below to update the results."
                  : "Choose your location and date to see available courses near you."}
              </p>
            )}
          </div>
        </section>
        <SearchCourse />
        <section className="section-60 bg-white pt-4 pt-md-0">
          <div className="container container-670">
            <Courses />
            <div className="items items-40">
              <Guarantees />
              <Accreditations />
              <FAQ />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};
